import { useEffect, useState } from "react";
import httpclient from "../../../Utils";


export const useCompaniesData = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let response;
        try {
          response = await httpclient.get(
            "/request-response?requestName=lightspeed/advanced-report/companies"
          );
        } catch (apiError) {
          console.warn("API call failed", apiError);
          return;
        }

        const data = response.data;

        const transformedCompanies = data.map((company) => ({
          id: company.id,
          name: company.name,
        }));

        setCompanies(transformedCompanies);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { companies, loading, error };
};
